import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section className="hero-section">
      <div className="container">
        <h1 className="hero-title">Build the AI workforce of tomorrow</h1>
      </div>
      <div className="hero-image-container">
        <img 
          src="https://sendbird.imgix.net/cms/Sendbird-team-photo_2025-02-06-0.webp?wm=webp" 
          alt="Sendbird Team" 
          className="hero-image"
        />
      </div>
    </section>
  );
}

export default Hero;